import { Component } from '@angular/core';
import { RouterLink } from "@angular/router";
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';
import { FeatureRow } from '../../../../widgets/feature-row/feature-row';

@Component({
  selector: 'app-assets-lifecycle-management',
  templateUrl: './page.html',
  styleUrl: './page.scss',
  standalone: true,
  imports: [RouterLink, FeatureHero, FeatureRow],
})
export class LifecycleManagement {
  whatIsParagraphs = [
    "IT asset lifecycle management refers to the journey of overseeing and managing IT assets from the moment they are acquired until they are retired or disposed of. There are several stages, such as planning, procurement, deployment, maintenance, and decommissioning. By systematically managing these stages, organizations can maximize the value of IT assets.",
    "IT asset lifecycle management also ensures that each asset is utilized to its fullest potential and is maintained properly throughout its life. Organizations can also make informed decisions about asset utilization, maintenance, and replacement."
  ];

  solutionParagraphs = [
    "Infraon's IT asset lifecycle management solution offers real-time tracking and monitoring for maintaining accurate records of asset status, location, and usage. This real-time visibility helps in making informed decisions regarding asset allocation, retirement, etc.",
    "Also, Infraon's IT asset lifecycle management solution is equipped with analytics and reporting features, offering insights into trends and patterns. So, it becomes streamlined to strategically plan and optimize the ROI of IT assets.",
    "You can make it tremendously easy to manage IT assets while lowering costs and elevating overall operational performance."
  ];

  otherFeaturesItems = [
    'Customizable Dashboards',
    'User and Role Management',
    'Audit Trails',
    'Mobile Accessibility'
  ];

  smoothIntegrationParagraph = ["Seamlessly integrate with your existing IT infrastructure, guaranteeing a transition and minimal disruptions."];
  tailoredWorkflowsParagraph = ["Customize workflows to align with your processes and requirements, ensuring IT assets adapt to your needs."];
  costOptimizationParagraph = ["Prevent licensing expenses and prolong asset lifecycles to achieve substantial long-term cost savings."];
  higherEfficiencyParagraph = ["Streamline tasks and administrative burdens, empowering your IT team to concentrate on higher-value initiatives."];
  complianceParagraph = ["Ensure compliance with agreements, industry regulations, and data security standards while mitigating risks."];
  transparencyParagraph = ["Get control, visibility, and analysis of all IT assets with real-time discovery and automatic reconciliation to provide actionable asset data."];

  bestPracticesParagraph = ["Some of the best practices followed by Infraon's IT Asset Lifecycle Management solution are:"];
  bestPracticesItems = [
    'Centralized tracking system to monitor and manage all IT assets from procurement to disposal',
    'Standard procurement processes to ensure control over IT asset acquisitions',
    'Scheduled maintenance, including software/hardware updates, etc.',
    'Auditing to verify the accuracy of records and assess the condition of IT assets',
    'Clear disposal strategy for decommissioning IT assets'
  ];

  benefitsParagraph = ["Implementing Infraon's IT asset lifecycle management solution can lead to:"];
  benefitsItems = [
    'Intelligent asset utilization to optimize the deployment and utilization of IT resources',
    'Improved financial planning to help in predicting and controlling IT expenses',
    'Increased asset longevity by preventing premature asset failures',
    'Standardized processes for quicker resolution of issues and less downtime',
    'Stronger vendor relationships with a data-driven approach toward negotiations'
  ];

  constructor() {}

}